// extracted by mini-css-extract-plugin
module.exports = {"sortableHandle":"sortableHandle--2yy0NaPVlW"};